import React from "react";
import Avatar from "../components/Avatar";

//Creating our home page

const Home = () => {
  return (
  <section>
    <div>
     <Avatar/>
    </div>

    <h2 className="userName">John Smith</h2>

    <div>
      <p className="userBio">John is a popular Real-Estate Merchant in Canada</p>
    </div>
  </section>
  ) 
};

export default Home;
